import React, { Component } from 'react'
import SidebarModal from 'components/SidebarModal'
import PropTypes from 'prop-types'

export class ItemEdit extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.any,
  }

  render() {
    const { children, title, onClose } = this.props
    return (
      <SidebarModal className="-narrow" onClose={onClose} show title={title}>
        {children}
      </SidebarModal>
    )
  }
}

export default ItemEdit
